export const VISITORS_INVALIDATED = 'VISITORS_INVALIDATED';